import axios from 'axios';
const API_BASE = (process.env.REACT_APP_API_BASE_URL || '') + '/api/';
const API_URL = API_BASE+'auth/token/';

export async function login(username: string, password: string) {
  const response = await axios.post(API_URL, { username, password });
  if (response.data.access) {
    localStorage.setItem('token', response.data.access);
    localStorage.setItem('refresh', response.data.refresh);
  }
  return response.data;
}

export function logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('refresh');
}

export function getToken() {
  return localStorage.getItem('token');
}
